<mat-card class="ra-card" style="margin: 16px;">
    <mat-card-content>
        <router-outlet></router-outlet>
    </mat-card-content>
</mat-card>
